import { render, staticRenderFns } from "./lider.vue?vue&type=template&id=4d190661"
import script from "./lider.vue?vue&type=script&lang=js"
export * from "./lider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports